import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

export const URL_MASSOPS = `${URL_APP_ADMIN}/massops`
const URL_MASSOPS_INTERVENTION = `${URL_MASSOPS}/intervention/:interventionId`
export const URL_MASSOPS_APPROVAL_REQUEST = `${URL_MASSOPS}/approval-request/:approvalRequestId`
// @hygen:inject admin-urls

export type MassopsDashRouteSet =
  | DashRouteType<'app-admin-massops-intervention'>
  | DashRouteType<'app-admin-massops-approval-request'>
// @hygen:inject dash-route-set

export const massopsRoutes: { [Key in MassopsDashRouteSet['identifier']]: string } = {
  'app-admin-massops-intervention': URL_MASSOPS_INTERVENTION,
  'app-admin-massops-approval-request': URL_MASSOPS_APPROVAL_REQUEST,
  // @hygen:inject route-pair
}

export type MassopsDomainRouteName = keyof typeof massopsRoutes
